import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import omit from 'lodash/omit';
import { margin, width } from 'styled-system';
import { flexItem } from './flexItem';
export default omit;
export var omitMargins = function omitMargins(obj) {
  for (var _len = arguments.length, undesired = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    undesired[_key - 1] = arguments[_key];
  }

  return omit.apply(void 0, [obj, 'm', 'margin', 'mt', 'marginTop', 'mr', 'marginRight', 'mb', 'marginBottom', 'ml', 'marginLeft', 'mx', 'marginX', 'my', 'marginY'].concat(undesired));
};

function extractor(keys) {
  return function (props) {
    return split(props, keys);
  };
}

export var extractMargins = extractor(margin.propNames);
var FIELD_STYLE_PROPS = ['className'].concat(_toConsumableArray(margin.propNames), _toConsumableArray(width.propNames), _toConsumableArray(flexItem.propNames));
export var extractFieldStyleProps = extractor(FIELD_STYLE_PROPS);
// WARNING: if any of the keys K are required in P, `props` may not match type P after extraction.
export var split = function split(props) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var keys = Array.isArray(args[0]) ? args[0] : args;
  return keys.reduce(function (extracted, key) {
    if (key in props) {
      extracted[key] = props[key];
      delete props[key];
    }

    return extracted;
  }, {});
};

/*
 * Intended for use in the `shouldForwardProp` function:
 *
 * const styleProps = getOmittableProps(margin)
 * const X = styled.div.withConfig({ shouldForwardProp: (p) => !styleProps.has(p) })``
 *
 * I'd rather cut a little boilerplate and return the entire function or config
 * object, but for some reason Typescript refuses to infer the type correctly,
 * even if I explicitly set the type to what Typescript infers in the above code.
 */
export var getOmittableProps = function getOmittableProps() {
  var omittableProps = new Set();

  var add = function add(x) {
    return omittableProps.add(x);
  };

  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var arg = _args[_i];

    if (typeof arg === 'string') {
      add(arg);
    } else if (Array.isArray(arg)) {
      arg.forEach(add);
    } else if (arg.propNames) {
      arg.propNames.forEach(add);
    }
  }

  return omittableProps;
}; // 3rd party type constraint, have to just ignore it.
// eslint-disable-next-line @typescript-eslint/ban-types

export var omitProps = function omitProps() {
  var excludedProps = getOmittableProps.apply(void 0, arguments);
  return {
    shouldForwardProp: function shouldForwardProp(p) {
      return !excludedProps.has(p);
    }
  };
};
export var getDataProps = function getDataProps(props) {
  return Object.keys(props).reduce(function (dataProps, prop) {
    var _prop$startsWith;

    if ((_prop$startsWith = prop.startsWith) !== null && _prop$startsWith !== void 0 && _prop$startsWith.call(prop, 'data-')) {
      // @ts-ignore
      dataProps[prop] = props[prop];
    }

    return dataProps;
  }, {});
};